import { useSetApproveAgreementsMutation } from '../qna.gql.impl';

const useSetApproveAgreements = () => {
  const { mutateAsync: setApproveAgreementMutate } = useSetApproveAgreementsMutation();
  return {
    setApproveAgreementMutate,
  };
};

export default useSetApproveAgreements;
